var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { parseLocalDate } from '@/shared/functions/customDate';
// Enum for project priority
export var Priority;
(function (Priority) {
    Priority["HIGH"] = "Alta";
    Priority["NORMAL"] = "Normal";
    Priority["LOW"] = "Baixa";
})(Priority || (Priority = {}));
export var parseProject = function (data) {
    if (!data)
        return null;
    return __assign(__assign({}, data), { dateStart: parseLocalDate(data.dateStart), dateEnd: data.dateEnd ? new Date(data.dateEnd) : null, createdAt: data.createdAt ? new Date(data.createdAt) : null, updatedAt: data.updatedAt ? new Date(data.updatedAt) : null });
};
